module.exports = __webpack_public_path__ + "img/repeat.7194f9fb.svg";